import { get, post } from "../utils/api";

export const fetchInvitations = () => {
  return get(`/group-cart/members-invitation`);
};

export const acceptInvitation = (invitationId,groupCartId) => {
  return post(`/group-cart/accept-invitation?invitationId=${invitationId}&groupCartId=${groupCartId}`);
};

export const rejectInvitation = (invitationId,groupCartId) => {
  return post(`/group-cart/reject-invitation?invitationId=${invitationId}&groupCartId=${groupCartId}`);
};



export const invitationsApi = {
  fetchInvitations,
  acceptInvitation,
  rejectInvitation,
};
